import { get } from './apiClient';
import { urls, imageUrl, PLACEHOLDER_IMAGE } from './urlService';

function mapProduct(p) {
  let images = p.images || [];
  if (typeof images === 'string') { try { images = JSON.parse(images); } catch { images = []; } }
  if (!Array.isArray(images)) images = [];

  const prices = (p.variants || []).map(v => ({
    weight: v.label,
    price: v.price,
    mrp: v.mrp,
  }));

  const mainImage = imageUrl(p.image || (images[0])) || PLACEHOLDER_IMAGE;
  const mappedImages = images.map(img => imageUrl(img)).filter(Boolean);
  if (mappedImages.length === 0) mappedImages.push(mainImage);

  return {
    id: p.id,
    name: p.name,
    slug: p.slug,
    price: prices[0]?.price || 0,
    mrp: prices[0]?.mrp || 0,
    category: p.childCategory?.name || p.subCategory?.name || p.category?.name || p.Category?.name || '',
    parentCategory: p.Category?.name || p.category?.name || '',
    image: mainImage,
    images: mappedImages,
    rating: parseFloat(p.rating) || 0,
    discount: p.discount || 0,
    bestSelling: p.bestSelling || false,
    description: p.description || '',
    prices,
    variants: p.variants || [],
    categoryId: p.categoryId,
    subCategoryId: p.subCategoryId,
    childCategoryId: p.childCategoryId,
    vendorId: p.vendorId || null,
    allLocations: p.allLocations !== false,
  };
}

export function slugify(name) {
  return name?.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || '';
}

export function getPriceForWeight(product, weight) {
  if (product.prices && product.prices.length > 0) {
    const match = product.prices.find(p => p.weight === weight);
    if (match) return match.price;
  }
  return product.price;
}

let allProductsCache = null;
let allProductsPromise = null;

export const GetAllProduct = async () => {
  if (allProductsCache) return allProductsCache;
  if (allProductsPromise) return allProductsPromise;

  allProductsPromise = (async () => {
    try {
      const data = await get(`${urls.products}?limit=500`);
      const products = data.products || data.rows || (Array.isArray(data) ? data : []);
      allProductsCache = products.map(mapProduct);
      return allProductsCache;
    } catch (error) {
      console.error('Error fetching products:', error);
      allProductsPromise = null;
      return [];
    }
  })();

  return allProductsPromise;
};

export const GetProductBySlug = async (slug) => {
  try {
    const data = await get(urls.productBySlug(slug));
    return mapProduct(data);
  } catch (error) {
    console.error('Error fetching product by slug:', error);
    return null;
  }
};

export const GetByCategory = async (categorySlug, location, extraParams = {}) => {
  try {
    const data = await get(urls.productsByCategory(categorySlug, { limit: 100, ...extraParams }));
    const products = data.products || data.rows || (Array.isArray(data) ? data : []);
    return products.map(mapProduct);
  } catch (error) {
    console.error('Error fetching products by category:', error);
    return [];
  }
};

export const GetRandomProducts = async (count = 8) => {
  try {
    const data = await get(urls.randomProducts(count));
    const products = Array.isArray(data) ? data : (data.products || []);
    return products.map(mapProduct);
  } catch (error) {
    console.error('Error fetching random products:', error);
    return [];
  }
};

export const GetBestSellingProducts = async (count = 10) => {
  try {
    const data = await get(urls.bestSelling(count));
    const products = Array.isArray(data) ? data : (data.products || []);
    return products.map(mapProduct);
  } catch (error) {
    console.error('Error fetching best selling products:', error);
    return [];
  }
};

export const GetRelatedProducts = async (productId, count = 8) => {
  try {
    const data = await get(urls.relatedProducts(productId, count));
    const products = Array.isArray(data) ? data : (data.products || []);
    return products.map(mapProduct);
  } catch (error) {
    console.error('Error fetching related products:', error);
    return [];
  }
};

export const SearchProducts = async (query, params = {}) => {
  try {
    const data = await get(urls.productsByCategory('', { ...params, q: query, limit: 50 }));
    const products = data.products || data.rows || (Array.isArray(data) ? data : []);
    return { products: products.map(mapProduct), total: data.total || products.length };
  } catch (error) {
    console.error('Error searching products:', error);
    return { products: [], total: 0 };
  }
};

export const QuickSearchProducts = async (query, limit = 8) => {
  if (!query || !query.trim()) return [];
  try {
    const data = await get(`${urls.products}?q=${encodeURIComponent(query.trim())}&limit=${limit}`);
    const products = data.products || data.rows || (Array.isArray(data) ? data : []);
    return products.map(mapProduct);
  } catch (error) {
    console.error('Error in QuickSearchProducts:', error);
    return [];
  }
};

